export default "select definition\n  from sys.view\n where database_id = $(database_id)\n   and view_id = $(view_id)\n"